import React from 'react'
import Text from '../text'
import * as styles from './PortfolioAttribute.css'

export const PortfolioAttribute = ({ type, title, val }) => {
  if (type === 'netIRR') {
    val = val + '\u2006%'
  }
  return (
    <div className={styles.portfolioAttr}>
      <Text color='var(--ib-muted)' size='0.7' bold className={styles.attrTitle}>
        {title}
      </Text>
      <Text
        color={type === 'netIRR' ? 'var(--ib-good)' : 'var(--ib-ink)'}
        className={type === 'netIRR' ? styles.netIRR : styles.attrVal}
        size='0.9'
        bold
        number>
        {val}
      </Text>
    </div>
  )
}
